import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { firstValueFrom } from 'rxjs';
import { StoreService } from 'shared/services/store.service';

@Injectable({
  providedIn: 'root'
})
export class DefaultRouteGuard  {
  constructor(
    private router: Router,
    protected readonly storeService: StoreService,
  ) {}

  async canActivate(): Promise<boolean> {

    const account = await firstValueFrom(this.storeService.getAccount());

    if (account.accountType === "SYSTEM_ADMIN") {
        this.router.navigate(['/system-admin-dashboard']);
        return false;
    } else {
        this.router.navigate(['/angebote']);
        return false;
    }
  }
}